import { httpClient } from 'shared/api/http-client'
import { RegisterConfirmApiInterface } from '../types/post-register-interface'
import { REGISTER_CONFIRM_API } from './constants'

export function registerConfirm(body: RegisterConfirmApiInterface) {
  return httpClient.post(REGISTER_CONFIRM_API, body)
}
